import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;

const instance = axios.create({
  baseURL: baseURL,
  timeout: 50000,
  headers: { 'Content-Type': 'application/json' }
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    // o sessionStorage, o desde donde guardes tu token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Reintento único ante cortes transitorios de red (sin response, ej. ERR_NETWORK
// o timeout) — solo para GET, porque es la única garantía de que reintentar no
// duplica una operación (un POST podría ser, por ejemplo, crear una solicitud).
// Un blip de red momentáneo (NAT/proxy cerrando una conexión idle, WiFi
// inestable) se recupera solo en vez de mostrarle un error de red al usuario
// mientras está llenando un formulario.
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;
    const esCorteDeRed = !error.response && (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED');
    const esGet = config?.method?.toLowerCase() === 'get';

    if (esCorteDeRed && esGet && config && !config._retried) {
      config._retried = true;
      return new Promise((resolve) => setTimeout(resolve, 1500)).then(() => instance(config));
    }

    return Promise.reject(error);
  }
);

export default instance;
